import { Injectable } from '@angular/core';
import { format, isValid, parse } from 'date-fns';
import * as i0 from "@angular/core";
export class DateTimeUtilityService {
    constructor() {
        this.dateTimeFormatString = 'MM/DD/YY h:mm A';
        this.dateFormatString = 'MM/DD/YY';
    }
    getFormatedDateTimeString(value) {
        return this.getFormatedDate(value, true);
    }
    getFormatedDateString(value) {
        return this.getFormatedDate(value, false);
    }
    getFormatedDate(value, withTime) {
        if (!value) {
            return null;
        }
        let date;
        if (withTime) {
            date = format(value, this.dateTimeFormatString);
        }
        else {
            date = format(value, this.dateFormatString);
        }
        return isValid(parse(date)) ? date : null;
    }
}
DateTimeUtilityService.ɵfac = function DateTimeUtilityService_Factory(t) { return new (t || DateTimeUtilityService)(); };
DateTimeUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DateTimeUtilityService, factory: DateTimeUtilityService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeUtilityService, [{
        type: Injectable
    }], null, null); })();
